module.exports = __webpack_public_path__ + "static/media/user-settings.025c4b22.svg";